module.exports = __webpack_public_path__ + "17006bc5ea6480672223f6282c519082-ui_communication_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/undergroundInfrastructure/assets/ui_communication_2x.png
// module id = 838
// module chunks = 0